import { createContext, useContext, type PropsWithChildren } from 'react'
import { useCloseModal } from '@/atoms'
import { ModalPublicProps } from '../types'

const cancelContext = createContext<() => void>(() => undefined)
const confirmContext = createContext<() => void>(() => undefined)

export function ContextProvider(props: PropsWithChildren<ModalPublicProps>) {
  const { children, onConfirm, onCancel } = props

  return (
    <confirmContext.Provider value={onConfirm}>
      <cancelContext.Provider value={onCancel}>{children}</cancelContext.Provider>
    </confirmContext.Provider>
  )
}

export function useOnConfirm() {
  const close = useCloseModal()
  const onConfirm = useContext(confirmContext)
  return () => {
    onConfirm()
    close()
  }
}

export function useOnCancel() {
  const close = useCloseModal()
  const onCancel = useContext(cancelContext)
  return () => {
    onCancel()
    close()
  }
}
